import KeyValueStore from "orbit-db-kvstore"
import React from "react"
import {Link} from "react-router-dom"
import {RepoMeta} from "../../../interfaces/repos"
import styles from "./index.module.scss"

interface WithReposContainerProps {
  profile: KeyValueStore<any>
  repos: RepoMeta[]
}

export const WithReposContainer = (props: WithReposContainerProps) => {
  const profileOrbitId = props.profile.address.root
  const profilePubKey = props.profile.address.path

  return (
    <div className={styles.ReposContainer}>
      {
        props.repos.map((repo: RepoMeta, idx: number) => {
          const styleClass = idx < props.repos.length - 1 ? styles.RepoRow : `${styles.RepoRow} ${styles.RepoRowLast}`
          const url = `./${repo.address.replace("/orbitdb", `${profileOrbitId}/${profilePubKey}`)}/codes`

          return (
            <Link key={repo.name}
                  to={url}
                  className={styleClass}
            >
              <div className={styles.RepoName}>
                {repo.name}
              </div>

              <div className={styles.RepoDesc}>
                {repo.description}
              </div>
            </Link>
          )
        })
      }
    </div>
  )
}
